import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import updateMetricsService from "../api/services/updateMetricsService";
import { handleApiError } from "../utils/apiHelpers";

export const changeMetrics = createAsyncThunk(
  "metrics/changeMetrics",
  async (data, thunkAPI) => {
    try {
      const response = await updateMetricsService.updateMetrics(data);
      if (response && response.data) {
        return response.data;
      }
      throw new Error("No data found");
    } catch (error) {
      handleApiError(error);
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchMetrics = createAsyncThunk(
  "metrics/fetchMetrics",
  async (outletId, thunkAPI) => {
    try {
      const response = await updateMetricsService.getMetrics(outletId);
      if (response && response.data) {
        return response.data;
      }
      throw new Error("No data found");
    } catch (error) {
      handleApiError(error);
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const pricingMetricsSlice = createSlice({
  name: "pricingMetrics",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    updatePricingMetrics: (state, action) => {
      state.data = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(changeMetrics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changeMetrics.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
      })
      .addCase(changeMetrics.rejected, (state, action) => {
        state.error = null;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchMetrics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMetrics.fulfilled, (state, action) => {
        state.data = action.payload;
        state.error = null;
        state.loading = false;
      })
      .addCase(fetchMetrics.rejected, (state, action) => {
        state.error = null;
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { updatePricingMetrics, setLoading, setError } =
  pricingMetricsSlice.actions;

export default pricingMetricsSlice.reducer;
